module.exports = __webpack_public_path__ + "img/BD.75f7daf7.png";